// DOM helpers for jQuery pages that answer an action in place (see
// docs/plans/alerts-redesign.md): an error under the control that failed,
// kept until the next attempt, or a label that flips to "✓ Saved" for two
// seconds. Each accepts a DOM element or a jQuery wrapper.
const FLASH_DURATION = 2000;

function toElement(target) {
	if(target && target.jquery) {
		return target[0] || null;
	}
	return target || null;
}

function directChild(container, className) {
	return Array.from(container.children).find((child) => child.classList.contains(className)) || null;
}

export function clearInlineError(target) {
	const container = toElement(target);
	if(!container) {
		return;
	}
	const existing = directChild(container, 'inline-error');
	if(existing) {
		existing.remove();
	}
}

export function showInlineError(target, message) {
	const container = toElement(target);
	if(!container) {
		return null;
	}
	clearInlineError(container);
	const error = container.ownerDocument.createElement('div');
	error.className = 'inline-error';
	error.setAttribute('role', 'alert');
	const icon = container.ownerDocument.createElement('i');
	icon.className = 'fa fa-exclamation-triangle';
	icon.setAttribute('aria-hidden', 'true');
	const text = container.ownerDocument.createElement('span');
	text.textContent = message;
	error.append(icon, text);
	container.appendChild(error);
	return error;
}

const originalLabels = new WeakMap();
const labelTimers = new WeakMap();

export function flashLabel(target, label, duration = FLASH_DURATION) {
	const element = toElement(target);
	if(!element) {
		return;
	}
	if(!originalLabels.has(element)) {
		originalLabels.set(element, element.textContent);
	}
	clearTimeout(labelTimers.get(element));
	element.textContent = label;
	element.classList.add('is-flashed');
	labelTimers.set(element, setTimeout(() => {
		element.textContent = originalLabels.get(element);
		element.classList.remove('is-flashed');
		originalLabels.delete(element);
		labelTimers.delete(element);
	}, duration));
}

export function flashNote(target, label, duration = FLASH_DURATION) {
	const container = toElement(target);
	if(!container) {
		return;
	}
	const existing = directChild(container, 'field_copied');
	if(existing) {
		existing.remove();
	}
	const note = container.ownerDocument.createElement('span');
	note.className = 'field_copied is-flashed';
	note.textContent = label;
	container.appendChild(note);
	setTimeout(() => note.remove(), duration);
}
